import { observer } from 'mobx-react-lite';
import { DetailsPage } from 'src/components/FormPages/DetailsPage';
import { SettingsLandingStore } from 'src/stores/SettingsStores/SettingsLandingStore/SettingsLandingStore';

export const LandingPageDetails = observer(() => {
    return <DetailsPage pageName="landing-page" store={SettingsLandingStore} />;
});
